<template>
  <div>
    <el-select class="filter__input" size="mini" v-model="localValue" filterable placeholder="请选择" @change="$emit('input', $event)">
      <el-option :label="item.label" :value="item.value" v-for="(item, index) in lists" :key="index"></el-option>
    </el-select>
  </div>
</template>
<script>
import {operLists} from '../../api/api'
export default {
  props: {
    value: {
      type: [String, Number], // 必须为字符串
      required: true, // 必须传递该属性
      default: '' // 未传值时的默认值
    },
    lists: {
      type: Array, // 必须为字符串
      default: () => []
    },
    filterLists: {
      type: Array, // 必须为字符串
      required: false, // 必须传递该属性
      default: () => [] // 默认值设为空数组
    },
    needEdit: {
      type: Boolean, // 必须为字符串
      required: false, // 必须传递该属性
      default: false // 未传值时的默认值
    }
  },
  data () {
    return {
      localValue: this.value,
      localLists: this.lists
    }
  },
  methods: {
    changeValue () {
      this.localValue = this.value
    },
    getLists () {
      let params = {
        l: 1000,
        p: 1,
        status: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.map((item, index) => {
            if (this.filterLists.length === 0 || this.filterLists.includes(item['opid'])) {
              this.localLists.push(
                {
                  label: item.nickname,
                  value: item.opid,
                  nickname: item.nickname,
                  opid: item.opid,
                  uid: item.uid
                }
              )
            }
          })
          if (this.needEdit === false) {
            this.localLists.unshift({
              label: '所有',
              value: '',
              nickname: '所有',
              opid: ''
            })
          }
          this.$emit('update:lists', this.localLists)
        }
      })
    }
  },
  mounted () {
    this.getLists()
  },
  watch: {
    'value': 'changeValue'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data-select/operSelect.vue